// https://stackoverflow.com/a/4770179/6951173
export class DomUtils {
	// left: 37, up: 38, right: 39, down: 40,
	// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
	public static keys: string[] = [
		'ArrowLeft',
		'ArrowUp',
		'ArrowRight',
		'ArrowDown',
		'Space',
		'PageUp',
		'PageDown',
		'Home',
		'End',
	];

	private wheelEvent = 'onwheel' in this.document.createElement('div') ? 'wheel' : 'mousewheel';

	private wheelOpt = { passive: false };

	constructor(
		private readonly document: Document,
		public elementsToAllow: HTMLElement[] = []
	) {}

	private preventDefault = this.preventDefaultBase.bind(this);
	private preventDefaultForScrollKeys = this.preventDefaultForScrollKeysBase.bind(this);

	private preventDefaultBase(e: Event): void {
		if (!this.elementsToAllow.includes(e.target as HTMLElement)) {
			e = e || window.event;
			if (e.cancelable) {
				e.preventDefault?.();
				e.returnValue = false;
			}
		}
	}

	private preventDefaultForScrollKeysBase(e: KeyboardEvent): boolean | void {
		if (
			DomUtils.keys.includes(e.code) &&
			!this.elementsToAllow.includes(e.target as HTMLElement)
		) {
			this.preventDefault(e);
			return false;
		}
	}

	public disableScroll(): void {
		// Older FF
		this.document.addEventListener('DOMMouseScroll', this.preventDefault, false);

		// Chrome
		this.document.addEventListener(this.wheelEvent, this.preventDefault, this.wheelOpt);

		// Mobile
		this.document.addEventListener('touchmove', this.preventDefault, this.wheelOpt);

		// Keyboard
		this.document.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
	}

	public enableScroll(): void {
		this.document.removeEventListener('DOMMouseScroll', this.preventDefault, false);
		this.document.removeEventListener(
			this.wheelEvent,
			this.preventDefault,
			this.wheelOpt as unknown as false
		);
		this.document.removeEventListener(
			'touchmove',
			this.preventDefault,
			this.wheelOpt as unknown as false
		);
		this.document.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
	}
}
